import { DateTime } from "@bps/date-time";

export const toLocalTime = (dateTimeString: string | undefined) => {
  if (dateTimeString) {
    return DateTime.fromISO(dateTimeString).toFormat("D tt");
  }
};
